module.exports = __webpack_public_path__ + "media/images/ico-sell-35c9f39e.png";